import { c, t } from "ttag";

import type { LengthParams, MaxLengthParams } from "./types";

export const required = () => t`заавал`;

export const email = () => t`мейл хаяг оруулна уу!`;

export const maxLength = ({ max }: MaxLengthParams) =>
  c("{0} is a number greater than 1").t`must be ${max} characters or less`;

export const exactLength = ({ length }: LengthParams) =>
  c("{0} is a number greater than 1").t`must be exactly ${length} characters`;

export const positive = () => t`эерэг утга оруулна уу!`;
